import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import handleUtmRedirect from '../../helpers/handleUtmRedirect';
import getPlatformUrlByCountry from '../../helpers/getPlatformUrlByCountry';
import { useIsMexicoDisabled } from '../../helpers/featureFlags';

function RegisterButton({ text, typographyVariant, sx }) {
  const isMexicoDisabled = useIsMexicoDisabled();
  if (isMexicoDisabled) {
    return null;
  }
  const platformUrl = getPlatformUrlByCountry();
  return (
    <Button
      id="register-button"
      variant="newPrimary"
      sx={{
        height: '3rem',
        gap: '0.5rem',
        ...sx,
      }}
      onClick={() => handleUtmRedirect(`${platformUrl}/user-register`)}
    >
      <Typography
        variant={typographyVariant}
        color="white"
        fontWeight={600}
      >
        {text}
      </Typography>
    </Button>
  );
}

RegisterButton.propTypes = {
  text: PropTypes.string,
  typographyVariant: PropTypes.string,
  sx: PropTypes.shape({
    height: PropTypes.string,
    gap: PropTypes.string,
  }),
};

RegisterButton.defaultProps = {
  text: 'Registrarme',
  typographyVariant: 'medium_2',
  sx: {},
};

export default RegisterButton;
